import React, { useState, useEffect, useRef, useContext } from 'react';
import { coreAxios } from "utilities/axios";
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FiEdit } from "react-icons/fi";
import { CommonButton } from "components/Buttons/Buttons";
import { MasterButton } from "components/Buttons/MasterButton";


//NEW
import AuthContext from  "../../context/AuthContext";
import { InputField } from "components/InputField/Input";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetWorkOrderItemsForChalan } from 'services/workorder/workOrder.service';

import { AddChalan, UpdateChalan, DeleteChalan, GetChalanListByShop, GetChalanItems, GetChalanDetail } from 'services/chalan/chalan.service';
import { GetWorkOrderNames } from 'services/dropdown/dropdown.service';

import { Table } from 'components/Table/Table';
import { TableDetail } from 'components/Table/TableDetail';
import { TableForm } from 'components/Table/TableForm'
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { ChalanValidationSchema } from 'utilities/ValidationSchema/Chalan/ChalanValidationSchema'
import useProductDataTable from './hook/useProductDataTable';
import { Card } from 'primereact/card';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const Chalan = () => {

    const { chalanList, chalanListLoading } = useSelector((state) => state.chalanByShopList);
    const { chalanAdd, chalanAddLoading } = useSelector((state) => state.chalanAdd);
    const { chalanUpdate, chalanUpdateLoading } = useSelector((state) => state.chalanUpdate);
    const { deleteChalan } = useSelector((state) => state.deleteChalan);


    const { chalanItems, chalanItemsLoading } = useSelector((state) => state.chalanItems);
    const { workOrderItemsForChalan, workOrderItemsForChalanLoading } = useSelector((state) => state.workOrderItemsForChalanList);
    const { chalanDetail, chalanDetailLoading } = useSelector((state) => state.chalanDetail);

    const [autoRequisitionFilteredValue, setAutoRequisitionFilteredValue] = useState([]);

    const [date, setDate] =useState(new Date());

    const { workOrderNameList, workOrderNamesLoading } = useSelector((state) => state.workOrderNames);


    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [showDetail, setShowDetail] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const { user } = useContext(AuthContext);

    const [ workOrderID, setWorkOrderId ] = useState();
    const [ chalanDate, setChalanDate ] = useState();
    const [ remark, setRemark ] = useState();

    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        work_order: workOrderNameList?.find((value) => value.id === workOrderID) || "",
        chalan_date: chalanDate || date,
        supplier_chalan_no: "",
        remark: remark || "",
        order_items: workOrderItemsForChalan?.map((value) => {
            return {
                ...value,
                name: value.requisition_item?.name,
                uom: value.requisition_item?.uom,
                product_expiry_date: date,
                order_quantity: value.requisition_item?.order_quantity,
                receive_quantity: value.requisition_item?.order_quantity,
                sale_price: value?.unit_price + (value?.unit_price * 1.5)/100,
            };
        }) || [
            {
                id: 0,
                name: "",
                uom: "",
                brand_name: "",
                product_expiry_date: date,
                order_quantity: 0,
                receive_quantity: 0,
                unit_price: 0.0,
                sale_price: 0.0,
                remark: "",
            },
        ],
    };


    const updateInitialValue = {
        id: updateData?.id,
        work_order: workOrderNameList?.find((value) => value.id === updateData?.work_order) || "",
        chalan_date: new Date(updateData?.chalan_date),
        supplier_chalan_no: updateData?.supplier_chalan_no,
        remark: updateData?.remark,
        order_items: chalanItems?.map((value) => {
            return {
                ...value,
                product_expiry_date: new Date(value?.product_expiry_date),
            };
        }) || [
            {
                id: 0,
                name: "",
                uom: "",
                brand_name: "",
                product_expiry_date: date,
                order_quantity: 0,
                receive_quantity: 0,
                unit_price: 0.0,
                sale_price: 0.0,
                remark: "",
            },
        ],

    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: ChalanValidationSchema, // * yup schema validation
        onSubmit: (values) => {

            const modifiedData = {
                ...values,
                work_order: values.work_order?.id,
                order_items: values.order_items.map((value) => {
                    return{
                        id: value.id, // For add & update use same variable
                        product_name: value.name, // For add & update use same variable
                        product_expiry_date: value.product_expiry_date || date,
                        receive_quantity: value.receive_quantity || 0,
                        grn_price: value.unit_price || 0,
                        buy_price: value.unit_price || 0,
                        sale_price: value.sale_price || 0,
                        remark: value.remark || "",
                    }
                })
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns } = useProductDataTable(
        formik, 
        setShowForm, 
        setUpdateData,
    );


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();
    

    const updateChalan = (chalan) => {
        dispatch(GetWorkOrderNames({'shop': user?.shop_id, 'status': 'True'}));

        setShowForm(true); // * set the form to true
        dispatch(GetChalanItems(chalan?.id))
        setUpdateData(chalan);
    };

    const chalanDetails = (chalan) => {

        setShowDetail(true); // * set the form to true
        dispatch(GetChalanDetail(chalan?.id))
        // setUpdateData(chalan);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteChalan(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetChalanListByShop(user?.shop_id));
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateChalan(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddChalan(data)).then(() => {
            hideModal();
            return
        });
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowDetail(false);
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();

        dispatch(GetWorkOrderItemsForChalan(0));

        setWorkOrderId();
        setChalanDate();
        setRemark();
    };

    useEffect(() => {
        dispatch(GetChalanListByShop(user?.shop_id));
        dispatch(GetWorkOrderNames({'shop': user?.shop_id, 'status': 'False'}));
    }, [chalanAdd, chalanUpdate, deleteChalan]);


    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "Chalan", sortableBody: NameColumn },
        { field: "date", header: "Chalan Date", sortableBody: TextColumn },
        { field: "work_order_name", header: "Work Order", sortableBody: TextColumn },
        { field: "supplier", header: "Supplier", sortableBody: TextColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
    ];

    const detailTableColumns = [
        { field: "name", header: "Item", sortableBody: NameColumn },
        { field: "expiry_date", header: "Expire Date", sortableBody: TextColumn },
        { field: "uom", header: "Uom", sortableBody: TextColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
        { field: "brand_name", header: "Brand", sortableBody: TextColumn },
        { field: "order_quantity", header: "Order Quantity", sortableBody: TextColumn },
        { field: "receive_quantity", header: "Receive Quantity", sortableBody: TextColumn },
        { field: "unit_price", header: "Unit Price", sortableBody: TextColumn },
        { field: "sale_price", header: "Sale Price", sortableBody: TextColumn },
        { field: "discount", header: "Discount", sortableBody: TextColumn },
        { field: "total_unit_price", header: "Total", sortableBody: TextColumn },
    ];

    const searchRequsition = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && workOrderNameList !== undefined) {
                setAutoRequisitionFilteredValue([...workOrderNameList]);
            } else {
                setAutoRequisitionFilteredValue(
                    workOrderNameList?.filter((requisition) => {
                        return requisition.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    function loadRequsitionItems(e) {
        e.preventDefault();

        dispatch(GetWorkOrderItemsForChalan(formik.values['work_order']['id']))

        setWorkOrderId(formik.values['work_order']['id'])
        setChalanDate(formik.values['chalan_date'])
        setRemark(formik.values['remark'])
    }


    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "work_order",
            name: "work_order",
            type: "select",
            labelFor: "work_order",
            label: "Select Work Order",
            required: true,
            disabled: updateData ? true : false,
            className: "col-12 md:col-3",
            OnChange: (e) => loadRequsitionItems(e),
            autoFilteredValue: autoRequisitionFilteredValue,
            autoCompleteMethod: searchRequsition,
            selectedAutoValue: workOrderNameList,

        },
        {
            id: "chalan_date",
            name: "chalan_date",
            value: "chalan_date",
            type: "date",
            labelFor: "chalan_date",
            label: "Chalan Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "supplier_chalan_no",
            name: "supplier_chalan_no",
            value: "supplier_chalan_no",
            type: "text",
            labelFor: "Supplier Chalan No",
            label: "Supplier Chalan No",
            disabled: updateData ? true : false,
            required: true,
            messagePosition: 'toast',
            className: "col-12 md:col-2",
        },
        {
            id: "remark",
            name: "remark",
            value: "remark",
            type: "text",
            labelFor: "Remark",
            label: "Remark",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-3",
        },
        {
            id: 'button',
            name: 'Load Requisition Items',
            type: 'button',
            label: 'Load Work Order Items',
            className: "col-12 md:col-2",
            btnColor: 'secondary',
            disabled: updateData,
            onClick: loadRequsitionItems,
            loading: workOrderItemsForChalanLoading,
        }
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        user.user_type === 'ADMIN' ? 
                        <>
                            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => updateChalan(rowData)} />
                            <Toast ref={toast} />
                            <ConfirmPopup />
                            <Button 
                                onClick={(e) => {
                                    DeleteModal(e, rowData.id);
                                }} 
                                icon="pi pi-trash" 
                                className="p-button-rounded p-button-warning mr-2"
                            />
                        </>
                        : <></>
                    }
                    <Button 
                        icon="pi pi-list" 
                        className="p-button-outlined p-button-info mr-2" 
                        onClick={(e) => {
                            chalanDetails(rowData)
                        }}
                    />
                    
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                //data
                tableHeaderName="Chalan Details"
                tableColumns={tableColumns}
                data={chalanList}
                loading={chalanListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <Dialog 
                visible={showForm} 
                style={{ width: "1400px" }} 
                header={`${updateData ? "Update" : "Create"} Chalan`} 
                className="p-fluid" 
                onHide={hideModal} 
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                    {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                            
                        <div key={id} className={`p-field ${className}`} >
                            <InputField
                                id={id}
                                type={type}
                                required={required}
                                name={name}
                                errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                label={label}
                                labelFor={labelFor}
                                rows={rows}
                                value={formik.values[name]}
                                autoCompleteMethod={autoCompleteMethod}
                                autoFilteredValue={autoFilteredValue}
                                onChange={(...args) => {
                                    !onChange && formik.handleChange(...args);
                                    onChange?.(...args);
                                }}
                                onBlur={onBlur}
                                onClose={() => formik.setErrors({})}
                                {...rest}
                            />
                        </div>
                    ))}


                    <div className="col-12">
                        <div className="w-full">
                            <TableForm
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.order_items}
                                loading={workOrderNamesLoading}
                                dataKey="productID"
                                actionButtonWidth={10}
                            />
                        </div>
                    </div>
                    <MasterButton resetForm={resetForm} update={updateData} loading={workOrderNamesLoading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                </form>
            </Dialog>

            <Dialog 
                visible={showDetail} 
                style={{ width: "1400px" }} 
                // header="Chalan Details"
                className="p-fluid" 
                onHide={hideModal} 
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                {
                    chalanDetail && 
                    (
                    <div className='grid'>
                        <div className='col-6'>
                            <Card title="Chalan Details" style={{ height: '165px', marginRight: '10px' }}>
                                <div>
                                    <strong>Chalan ID: </strong> {chalanDetail.name}
                                </div>
                                <div>
                                    <strong>Supplier Chalan No: </strong> {chalanDetail.supplier_chalan_no}
                                </div>
                                <div>
                                    <strong>Date: </strong> {chalanDetail.date}
                                </div>
                                <div>
                                    <strong>Work Order: </strong> {chalanDetail.work_order_name}
                                </div>
                                <div>
                                    <strong>Remark: </strong> {chalanDetail?.remark}
                                </div>
                            </Card>
                        </div>
                        <div className='col-6'>
                            <Card title="Supplier Details" style={{ height: '165px' }}>
                                <div>
                                    <strong>Name: </strong> {chalanDetail.supplier}
                                </div>
                                <div>
                                    <strong>Contact Name: </strong> {chalanDetail.supplier_contact_name}
                                </div>
                                <div>
                                    <strong>Contact Number: </strong> {chalanDetail.supplier_contact_number}
                                </div>
                                <div>
                                    <strong>Address: </strong> {chalanDetail.supplier_address}
                                </div>
                            </Card>
                        </div>
                    </div>
                    )
                }
                
                <Divider align="center">
                    <span className="p-tag">Chalan Items Details</span>
                </Divider>

                <TableDetail
                    tableColumns={detailTableColumns}
                    data={chalanDetail.chalan}
                    loading={chalanDetailLoading}
                    dataKey="id"
                />
            </Dialog>
        </>
    );
};

export default Chalan;
